import React from 'react';
import { Carousel } from 'react-bootstrap';
import './Products.css';

const ProductCarousel = ({ title, subtitle, images }) => (
  <div className="product-section">
    <h2 className="product-title">{title}</h2>
    <p className="product-subtitle">{subtitle}</p>

    <div className="carousel-wrapper">
      <Carousel interval={900} controls={true} indicators={true}>
        {images.map((img, idx) => (
          <Carousel.Item key={idx}>
            <div className="carousel-image-container">
              <img src={img} alt={`blur-${idx}`} className="carousel-blur-bg" />
              <img src={img} alt={`${title}-${idx}`} className="carousel-image" />
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  </div>
);



const steps = [
  { title: "Client Brief", image: "/images/brief.jpg" },
  { title: "Site Verification", image: "/images/verification.jpg" },
  { title: "Design Concept", image: "/images/concept.jpg" },
  { title: "Design Finalization", image: "/images/finalization.jpg" },
  { title: "Off-site Execution", image: "/images/execution.jpg" },
  { title: "Onsite Installation", image: "/images/installation.jpg" },
];



const Products = () => {
  return (
    <div className="product-page">
      <ProductCarousel
        title="Kitchen"
        subtitle="Elevate your home with the best of the kitchens"
        images={[
          "/images/kitchen1.jpeg",
          "/images/kitchen2.jpeg",
          "/images/kitchen3.jpeg",
          "/images/kitchen4.jpeg",
          "/images/kitchen5.jpeg"
        ]}
      />
      <ProductCarousel
        title="Wardrobes"
        subtitle="Wardrobe designs tailored to your taste"
        images={[
          "/images/w1.jpeg",
          "/images/w2.jpeg",
          "/images/w3.jpeg",
          "/images/w4.jpeg",
          "/images/w5.jpeg"
        ]}
      />
      <ProductCarousel
        title="TV Units"
        subtitle="TV unit for your modern home"
        images={[
          "/images/tv1.jpg",
          "/images/tv2.jpg",
          "/images/tv3.jpg",
          "/images/tv4.jpg",
          "/images/tv5.jpg"
        ]}
      />
      <ProductCarousel
        title="Loose Furniture"
        subtitle="Custom loose furniture for your needs"
        images={[
          "/images/furniture1.jpg",
          "/images/furniture2.jpg",
          "/images/furniture3.jpg"
        ]}
      />




      <div className="fancy-timeline orange-theme">


        <h2 className="timeline-heading">Our Process</h2>
        <div className="timeline-wrapper">
          <i className="fas fa-car-side car-icon"></i>
          {steps.map((step, index) => (
            <div
              key={index}
              className={`timeline-step ${index % 2 === 0 ? 'left' : 'right'}`}
              style={{ animationDelay: `${index * 0.3}s` }}
            >
              <div className="dot-glow"><span>{index + 1}</span></div>
              <div className="connector-line"></div>
              <div className="step-card">
                <img src={step.image} alt={step.title} />
                <h3>{step.title}</h3>
              </div>
            </div>
          ))}
          <div className="vertical-glow-line"></div>
        </div>
      </div>





    </div>
  );
};

export default Products;
